import React from "react";
import { Box, Stack, useTheme } from "@mui/material";
import CustomAutoComplete from "@/modules/common/components/input/dropdowns/auto-complete";
import SortInputToggle from "@/modules/common/components/input/sort-input-toggle";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
interface SectionHeaderFiltersProps {
  hasRightElement?: boolean;
  filterHookResult?: any;
}

const SectionHeaderFilters: React.FC<SectionHeaderFiltersProps> = ({
  filterHookResult,
}) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      bgcolor={theme.nawy.colors.semantic.layer.primary}
      padding={theme.nawy.spacing.md}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          width: "100%",
          gap: theme.nawy.spacing.xs,
        }}
      >
        <SortInputToggle
          sortOrder={filterHookResult?.sortOrder}
          onChange={filterHookResult?.handleSortChange}
          disabled={filterHookResult?.disabled}
          customPlaceholderSx={{
            ...theme.nawy.typography.english.variants.body.md.regular,
            color: theme.nawy.colors.semantic.text.secondary,
            width: "280px",
          }}
          fullWidth={false}
        />
        <CustomAutoComplete
          options={filterHookResult?.options}
          value={filterHookResult?.selectedOption}
          onChange={filterHookResult?.handleChange}
          placeholder={filterHookResult?.placeholder}
          fullWidth={filterHookResult?.fullWidth}
          loading={filterHookResult?.loading}
          disableClearable={true}
          customPlaceholderSx={{
            ...filterHookResult?.customPlaceholderSx,

            fontSize:
              nawyTheme.nawy.typography.english.variants.body.md.regular
                .fontSize,
            width: "110px",
            "& .MuiInputBase-input": {
              fontSize:
                nawyTheme.nawy.typography.english.variants.body.md.regular
                  .fontSize,
              height: "23px",
            },
            "& .MuiAutocomplete-popupIndicator": {
              color: nawyTheme.nawy.colors.semantic.text.primary,
              "& svg": {
                fontSize:
                  nawyTheme.nawy.typography.english.variants.headline.xs
                    .fontSize,
                color: nawyTheme.nawy.colors.semantic.text.primary,
              },
            },
          }}
        />
      </Box>
    </Stack>
  );
};

export default SectionHeaderFilters;
